"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));

var _cookieUtils = _interopRequireDefault(require("./cookieUtils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Method = {
  get: 'GET',
  post: 'POST',
  put: 'PUT',
  delete: 'DELETE'
};

class ErrorWithResponse extends Error {}

function filterUndefinedHeaders(headers) {
  const finalHeaders = {
    'Content-Type': 'application/json'
  };
  Object.keys(headers).forEach(key => {
    if (headers[key] !== undefined) {
      finalHeaders[key] = headers[key];
    }
  });
  return finalHeaders;
} // eslint-disable-next-line @typescript-eslint/no-explicit-any


const handleErrors = ([ok, response]) => {
  if (!ok) {
    const errorMessage = response.error && response.error.message || 'An error has occurred';
    const error = new ErrorWithResponse(errorMessage);
    error.response = response;
    throw error;
  }

  return response;
};

const handlePromise = response => {
  const contentType = response.headers && response.headers.get('Content-Type');

  if (contentType && contentType.indexOf('application/json') > -1) {
    return Promise.all([response.ok, response.json()]);
  }

  return Promise.all([response.ok, response.text()]);
};

const request = (url, options) => (0, _isomorphicFetch.default)(url, options).then(handlePromise).then(handleErrors);

const get = (url, options = {}, headers = {}) => {
  const finalHeaders = {
    'Content-Type': 'application/json',
    ...headers
  };
  const finalOptions = {
    method: Method.get,
    credentials: 'same-origin',
    headers: finalHeaders,
    ...options
  };
  return request(url, finalOptions);
};

const post = (url, body = {}, options = {}, headers = {}) => {
  const finalHeaders = filterUndefinedHeaders(headers); // filter all headers with value of undefined

  const finalBody = finalHeaders['Content-Type'] === 'application/json' ? JSON.stringify(body) : body;
  const finalOptions = {
    method: Method.post,
    credentials: 'same-origin',
    body: finalBody,
    headers: finalHeaders,
    ...options
  };
  return request(url, finalOptions);
};

const deleteMethod = (url, options = {}, headers = {}) => {
  const finalHeaders = {
    'Content-Type': 'application/json',
    ...headers
  };
  const finalOptions = {
    method: Method.delete,
    credentials: 'same-origin',
    headers: finalHeaders,
    ...options
  };
  return request(url, finalOptions);
};

const put = (url, body = {}, options = {}, headers = {}) => {
  const finalHeaders = filterUndefinedHeaders(headers); // filter all headers with value of undefined

  const finalBody = finalHeaders['Content-Type'] === 'application/json' ? JSON.stringify(body) : body;
  const finalOptions = {
    method: Method.put,
    credentials: 'same-origin',
    body: finalBody,
    headers: finalHeaders,
    ...options
  };
  return request(url, finalOptions);
}; // JASON TODO: Move cookie functions and this entire file to zola-helpers


const getCookie = (cookieName, req) => {
  if (!req.cookies) return undefined;
  return req.cookies[cookieName];
};

const getCookieHeader = req => {
  const authCookieNames = [_cookieUtils.default.getLoginCookieName(), _cookieUtils.default.getUserSessionCookieName(), _cookieUtils.default.getUserSessionRefreshCookieName()];
  const finalString = authCookieNames.reduce((acc, cookieName) => {
    const cookieValue = getCookie(cookieName, req);

    if (cookieValue) {
      return `${acc}${cookieName}=${cookieValue}; `;
    }

    return acc;
  }, '');
  return {
    Cookie: finalString
  };
};

const ApiService = {
  request,
  get,
  put,
  post,
  delete: deleteMethod,
  getCookieHeader
};
var _default = ApiService;
exports.default = _default;